import { EffectCallback, useEffect, DependencyList } from 'react';

// interface OptionTimer {
//     intervalTime?: number;
//     onTimeout?: () => void;
// }

// useEffectOnce(() => console.log('toto'))
// const useEffectOnce = (effect: EffectCallback): void => {
//     useEffect(
//         effect,
//         [],
//     );
// };

// const useMount = (fn: () => void) => {
//     useEffectOnce(() => {
//         fn();
//     });
// };

// useLifecycles(()=> console.log('onMount'), () => console.log('onUnmount'))
const useLifecycles = (mount: EffectCallback, unmount?: EffectCallback, deps: DependencyList = []): void => {
    useEffect(() => {
        if (mount) {
            mount();
        }
        return () => {
            if (unmount) {
                unmount();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

///////////// useCountDown
// const useCountdown = (timeout: number, options?: OptionTimer) => {
//     const { intervalTime = 1000, onTimeout } = options;

//     const [timeLeft, setTimeLeft] = useState<number>(timeout);

//     function tick(): void {
//         setTimeLeft((previousValue) => {
//             if (!isNaN(previousValue)) {
//                 if (previousValue <= 0) {
//                     OnExpired();
//                     return 0;
//                 }
//                 return previousValue - intervalTime;
//             }
//             return timeout;
//         });
//     }
//     function OnExpired(): void {
//         /* tslint:disable:react-hooks-nesting */
//         useEffectOnce(onTimeout);
//         handleInterval(false);
//     }
//     function handleInterval(start: boolean): void {
//         let interval: NodeJS.Timer;
//         if (start) {
//             interval = setInterval(() => tick(), intervalTime);
//         } else {
//             clearInterval(interval);
//         }
//     }

//     useEffect(() => {
//         if (timeLeft !== 0) {
//             handleInterval(true);
//         }

//         return () => handleInterval(false);
//     }, [timeout]);

//     return (timeLeft / 1000) as number;
// };

export { useLifecycles };
